import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  questionnaireList: [],
  questionnaireItem: {},
  loading: false,
};

const questionnaireSlice = createSlice({
  name: 'questionnaireSlice',
  initialState,
  reducers: {
    questionnaireLoadingSlice: (state, { payload }) => {
      state.loading = payload;
    },
    questionnaireListSlice: (state, { payload }) => {
      state.questionnaireList = payload;
    },
    questionnaireItemSlice: (state, { payload }) => {
      state.questionnaireItem = payload;
    },
  },
});

const { actions, reducer } = questionnaireSlice;

export const {
  questionnaireLoadingSlice,
  questionnaireListSlice,
  questionnaireItemSlice,
} = actions;

export default reducer;
